import {ReactElement, useEffect, useState} from "react";
import {Form, FormInstance, Space, Table} from "antd";
import {getExercises} from "../../services/ServiceExercises";
import {Link} from "react-router-dom";
import {Custom, keyedObject} from "../../utils/refineUtils";
import {ColumnsType} from "antd/es/table";
import {IConfigLAScholar} from "../../interfaces/IClientsConfig";

interface IProps {
    isEditable?: boolean
    index?: any,
    form?: FormInstance<{}>
    config?: {
        id: string,
        config: IConfigLAScholar
    }
}

export default function ConfigLAScholar(props: IProps): ReactElement | null {

    // Variables

    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [dataExercises, setDataExercises] = useState<any[]>([])
    const {exercises, isLoadingExercises} = getExercises()

    const createColumns = (title: string, dataIndex: string, key: string, render?: any) => {
        return {title, dataIndex, key, render}
    }

    const columns: ColumnsType<any> = [
        createColumns("Nom", "nom", "name"),
        createColumns("Langage", "langage", "language"),
        createColumns("Difficulté", "difficulte", "difficulty"),
        createColumns("Temps moyen", "tempsMoyen", "avrgTime")
    ]

    const onSelectChange = (newSelectedRowKeys: React.Key[], selectedRows: any[]) => {
        props?.form?.setFieldValue([props?.index, 'config', 'exercises'], selectedRows.map(exercise => exercise.id))
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        getCheckboxProps: () => ({
            disabled: !props?.isEditable
        })
    };

    useEffect(() => {
        setDataExercises(exercises ?? [])
        if(props?.isEditable) return;
        const idChoosenExercises: string[] = props?.form?.getFieldValue(["clients", props?.index, 'config','exercises']) ?? [];
        const exercisesChoosen = exercises?.filter((exercise: any) => idChoosenExercises?.includes(exercise.id));
        setDataExercises(exercisesChoosen ?? [])
        setSelectedRowKeys(Array.from({ length: (exercisesChoosen?.length ?? 0) + 1 }, (_, i) => i))
    },[props?.isEditable, isLoadingExercises])

    return (
        <Space direction="vertical" size="small" style={{width: "100%"}}>
            <Custom.Title title="Séléction des exercices">
                <Link style={{fontSize: "small"}} to="./exercices">Gérer les exercices</Link>
            </Custom.Title>
            <Form.Item style={{marginBottom: 0}} name={[props?.index, 'config', 'exercises']} initialValue={props?.isEditable ? [] : undefined}>
                <Table rowSelection={rowSelection} size="small" dataSource={keyedObject(dataExercises ?? [])} columns={columns}/>
            </Form.Item>
        </Space>
    )
}